import React, { memo, useRef, useState } from "react"

import parse from "html-react-parser"

import SectionsTitle from "../../../Common/new/SectionsTitle"

import { replaceUnderscoresWithSpaces } from "../../../utils/functions"

import * as style from "./style.module.css"
import LinkArrow from "../../svg/new/LinkArrow"
import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay, Navigation } from "swiper/modules"
// import useMarginLeft from "../../../hooks/useMarginLeft"

const DevelopmentProcess = props => {
  const { title, subTitle, content, developmentProcessList,developmentProcessShowSection} = props
  
  const swiperRef = useRef(null)
  // const marginLeft = useMarginLeft()
  const [currentIndex, setCurrentIndex] = useState(1)

  return (
    <>
    {developmentProcessShowSection === "yes" &&(
      <section className={``}>
      <div className="container">
        <SectionsTitle
          title={replaceUnderscoresWithSpaces(title)}
          SubTitle={subTitle}
          Content={content}
          styleCss={{ display: "none" }}
          classnames={style.dev_process_title}
        />
      </div>

      <div
        className={style.dev_process_content_wrap}
        // style={{ marginLeft: `${marginLeft}` }}
      >
        <Swiper
          modules={[Navigation, Autoplay]}
          speed={1000}
          loop={true}
          slidesPerView={3}
          spaceBetween={20}
          autoplay={{ delay: 1000 }}
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween:0
            },
            576: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 2,
            },
            1200: {
              slidesPerView: 3,
            },
          }}
          className="dev_process_swiper"
          onSwiper={swiper => (swiperRef.current = swiper)}
          onSlideChange={swiper => setCurrentIndex(swiper.realIndex + 1)}
        >
          {Array.isArray(developmentProcessList) &&
            developmentProcessList?.map((item, index) => {
              return (
                <SwiperSlide key={index}>
                  <div className={style.card}>
                    <div className={style.card_title_wrap}>
                      <i className={style.card_icon_wrap}>
                        {parse(`${item?.developmentProcessIcon}`)}
                      </i>
                      <h3 className={style.card_title}>
                        {item?.developmentProcessTitle}
                      </h3>
                    </div>
                    <p className={style.card_desc}>
                      {parse(`${item?.developmentProcessContent}`)}
                    </p>
                    <p className={style.card_count}>
                      {index < 10 ? `0${index + 1}` : index + 1}
                    </p>
                  </div>
                </SwiperSlide>
              )
            })}
        </Swiper>
      </div>

      <div className="container">
        <div className={style.navigation_wrap}>
          <button
            className={`${style.navigation_btn} ${style.prev_btn}`}
            onClick={() => swiperRef.current?.slidePrev()}
          >
            <LinkArrow />
          </button>
          <span className={style.navigation_content}>
            {currentIndex < 10 ? `0${currentIndex}` : currentIndex} -{" "}
            {developmentProcessList?.length < 10
              ? `0${developmentProcessList?.length}`
              : developmentProcessList?.length}
          </span>
          <button
            className={`${style.navigation_btn}`}
            onClick={() => swiperRef.current?.slideNext()}
          >
            <LinkArrow />
          </button>
        </div>
      </div>
    </section>
    )}
    </>
  )
}

export default memo(DevelopmentProcess)
